import React, { useContext } from 'react';
import { MediaContext } from 'react-media-query-hoc';
import { CardRow } from '@domain-group/fe-co-allhomes-design-system';
import AllhomesArticleCard from './allhomes-article-card';
import * as styles from './news-cards.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var NewsCards = _ref => {
  var _ref$articles = _ref.articles,
    articles = _ref$articles === void 0 ? [] : _ref$articles,
    className = _ref.className,
    _onClick = _ref.onClick;
  var _useContext = useContext(MediaContext),
    mobile = _useContext.mobile,
    tablet = _useContext.tablet;
  if (articles.length === 0) {
    return ___EmotionJSX(React.Fragment, null);
  }
  return ___EmotionJSX(CardRow, {
    hasScrollButtons: mobile || tablet,
    className: className
  }, articles.map((article, index) => ___EmotionJSX(AllhomesArticleCard, {
    article: article,
    target: "_self",
    rel: "noopener",
    appearance: "research",
    css: styles.newsCard,
    key: article.url,
    onClick: () => _onClick === null || _onClick === void 0 ? void 0 : _onClick(index)
  })));
};
export { NewsCards };